<template>
    <div class="main-window-l">
        <div class="step-nav">
            <div class="nav-item active">
                路演视频详情
            </div>
        </div>

        <div class="film-intro">
            <div class="top">
                <div class="top-l">
                    <h2>{{ filmData.name }}</h2>
                    <template v-if="!filmData.isOnlyShowVideo">
                        <p v-for="(item, index) in filmData.content.pList" :key="index">
                            {{ item }}
                        </p>
                        <h3>一句话梗概：</h3>
                        <p v-html="filmData.content.synopsis" class="text-justify"></p>
                    </template>
                </div>
                <img :src="imgComputed(filmData.head)" />
            </div>
            <div v-if="filmData.isOnlyShowVideo" class="botttom">
                <video name="videoArea" :src="videoComputed(filmData.videoZj, 'videoZj')" controls controlslist="nodownload" />
            </div>
            <div v-else class="botttom">
                <template v-if="filmData.content.directorIntro">
                    <h3>导演简介：</h3>
                    <p v-html="filmData.content.directorIntro" class="text-justify"></p>
                </template>
                <template v-if="filmData.content.heroIntro">
                    <h3>男主角简介：</h3>
                    <p v-html="filmData.content.heroIntro" class="text-justify"></p>
                </template>
                <template v-if="filmData.content.heroineIntro">
                    <h3>女主角简介：</h3>
                    <p v-html="filmData.content.heroineIntro" class="text-justify"></p>
                </template>
                <template v-if="filmData.content.writersIntro">
                    <h3>编剧简介：</h3>
                    <p v-html="filmData.content.writersIntro" class="text-justify"></p>
                </template>
                <template v-if="filmData.content.producerIntro">
                    <h3>制片人简介：</h3>
                    <p v-html="filmData.content.producerIntro" class="text-justify"></p>
                </template>
                <template v-if="filmData.content.produceCompanyIntro">
                    <h3>制片公司简介：</h3>
                    <p v-html="filmData.content.produceCompanyIntro" class="text-justify"></p>
                </template>
                <template v-if="filmData.content.superviseIntro">
                    <h3>监制简介：</h3>
                    <p v-html="filmData.content.superviseIntro" class="text-justify"></p>
                </template>
                <template v-if="filmData.content.outline">
                    <h3>故事大纲：</h3>
                    <p v-html="filmData.content.outline" class="text-justify"></p>
                </template>
                <template v-if="filmData.content.creation">
                    <h3>创作阐述：</h3>
                    <p v-html="filmData.content.creation" class="text-justify"></p>
                </template>
                
                <template v-if="filmData.video">
                    <h3>中期路演视频：</h3>
                    <video name="videoArea" :src="videoComputed(filmData.video, 'video')" controls controlslist="nodownload" />
                </template>
                <template v-if="filmData.videoZj">
                    <h3>终极路演视频：</h3>
                    <video name="videoArea" :src="videoComputed(filmData.videoZj, 'videoZj')" controls controlslist="nodownload" />
                </template>
            </div>
        </div>
        <div class="foo foo-center">
            <button class="leftBtn" @click="goBack">返回</button>
        </div>
    </div>
</template>

<script>
import filmJson from '@/static/roadShowFilm.json';
import { sessionData } from "@/static/js/local.js";

export default {
    data() {
        return {
            filmData: {}
        }
    },
    computed: {
        imgComputed() {
            return function(val) {
                let imgSrc = '';
                if(val && val !== '') {
                    imgSrc = process.env.VUE_APP_IMG_BASE_URL + 'images_annual/annual_detail_2023/' + val;
                }
                return imgSrc
            }
        },
        videoComputed() {
            return function(val, type) {
                let videoSrc = '';
                if(val && val !== '') {
                    videoSrc = process.env.VUE_APP_IMG_BASE_URL + 'images_annual/annual_detail_2023/'+ type + '/' + val;
                }
                return videoSrc
            }
        }
    },
    created() {
        if (!this.$cookies.isKey("token")) {
            this.$router.push("/login");
            return
        }
        let detailForm = sessionData("get", "UserInfo");
        let isInvestor = detailForm.details.some(item => item.guestType == "10" && item.verifyFlag == 1);

        if (!isInvestor) {
            this.$msgbox({
                title: "提示",
                message: "您还不是一对一洽谈创投嘉宾，请先报名成为创投嘉宾再进行观看",
                showClose: false,
                confirmButtonClass: "btn-color",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                callback: (action, instance) => {
                    if (action == "confirm") {
                        this.$router.push("/1v1/vc");
                    }
                }
            });
            return;
        }

        let id = this.$route.query.id;
        if (!id) {
            this.$message.warning('找不到该部影片信息，请重试');
            this.goBack();
            return
        }
        this.filmData = filmJson[this.$route.query.type + 'Film'].find(item => item.id === id);
    },
    mounted() {
        // 禁止视频右击
        $('[name="videoArea"]').bind('contextmenu',function() { return false; });
    },
    methods: {
        goBack() {
            this.$router.push({
                path: '/1v1/road_show',
                query: {
                    type: this.$route.query.type
                }
            });
        }
    }
}
</script>

<style src="../../static/css/regist.css" scoped></style>
<style src="../../static/css/infoCommon.css" scoped></style>
<style src="../../static/css/film.css" scoped></style>